// extracted by mini-css-extract-plugin
export default {"root":"BundleOverviewControllerActionIconsContainer_root__kpTZP","icon":"BundleOverviewControllerActionIconsContainer_icon__j8+9I"};